export interface AccessRules {
    hasBought: boolean;
    paidLevels: number; // Free levels for people who haven't bought the course
    currentLevel: number; // Learner's progress
}

// One rule for both sections and items (it was duplicated in the page before).
// Locked by payment: not bought and beyond the free levels.
// Locked by progress: only the next level after the current one is open.
export const isContentAccessible = (content: { level: number }, rules: AccessRules): boolean => {
    const lockedByPayment = !rules.hasBought && content.level > rules.paidLevels;
    const lockedByProgress = content.level > rules.currentLevel + 1;

    return !lockedByPayment && !lockedByProgress;
};